import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const ASPDOTNET = () => {
  return (
    <StartInterviewLayout type="asp-dotnet"/>
  )
}

export default ASPDOTNET;